import type { IconData } from '@stacksjs/iconify-core'

export const superscript: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.708 5.29L4.54 8.098L7.37 5.29a1.007 1.007 0 0 1 1.416 0a.986.986 0 0 1 0 1.403L5.955 9.5l2.83 2.806a.986.986 0 0 1 0 1.403a1.007 1.007 0 0 1-1.415 0l-2.83-2.806l-2.832 2.806a1.007 1.007 0 0 1-1.415 0a.986.986 0 0 1 0-1.403L3.123 9.5L.294 6.694a.986.986 0 0 1 0-1.403a1.007 1.007 0 0 1 1.415 0ZM11.686 0q.642 0 1.149.275q.51.28.814.8c.2.343.301.7.301 1.063c0 .416-.231.849-.46 1.307c-.223.45-.538.876-1.072 1.555l-.118.123l-.255.229H14V7H9.078V5.986l.101-.246l1.801-1.913c.433-.435.8-.77.93-1.011q.186-.346.184-.587a.42.42 0 0 0-.128-.327a.48.48 0 0 0-.355-.127a.45.45 0 0 0-.357.158c-.106.117-.167.288-.175.525l-.012.338h-1.84l.017-.366c.034-.735.274-1.33.723-1.77c.45-.44 1.03-.66 1.719-.66\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export default superscript
